import { useEffect, useState } from 'react';

/**
 * Shared state hook for the QuoteModal.
 * Also listens for the global 'vglm:open-quote' event dispatched by the
 * MobileCallBar (mounted at App level) so any page that renders a
 * <QuoteModal /> can be opened from the sticky mobile bar.
 */
export function useQuoteModal() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handler = () => setQuoteOpen(true);
    window.addEventListener('vglm:open-quote', handler);
    return () => window.removeEventListener('vglm:open-quote', handler);
  }, []);

  return [quoteOpen, setQuoteOpen];
}
